import { useEffect, useState, useCallback } from 'react';
import { apiFetch } from "../utils/api";

function useComplaints() {
  const [complaints, setComplaints] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchComplaints = useCallback(() => {
    setLoading(true);
    setError(null);

    apiFetch('/api/complaints')
      .then(async (res) => {
        if (!res) {
          return;
        }

        if (res.status === 403) {
          // No tiene permisos → lista vacía
          setComplaints([]);
          return;
        }

        if (!res.ok) {
          const body = await res.json().catch(() => ({}));
          const err = new Error(body?.error || 'Error loading complaints');
          err.status = res.status;
          throw err;
        }

        return res.json();
      })
      .then((data) => {
        if (data) setComplaints(data);
      })
      .catch((err) => {
        console.error('Error loading complaints:', err);
        setError(err);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    fetchComplaints();
  }, [fetchComplaints]);

  return { complaints, loading, error, fetchComplaints };
}

export default useComplaints;
